import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import type { IRowNode } from 'ag-grid-community';

import EntityButtons from 'components/EntityButtons';
import EntityDetailsContext from 'screens/EntityDetailsShow/EntityDetailsContext';
import { FleetOpsGridColDef } from 'types/agGrid';

const EntityLink = ({
  colDef,
  value,
  node,
}: {
  colDef: FleetOpsGridColDef;
  value: string | string[];
  node: IRowNode;
}) => {
  const { cellRendererParams } = colDef;
  const { entityDefinition } = cellRendererParams;
  const entityDetails = useContext(EntityDetailsContext);
  const [isRowHovered, setIsRowHovered] = useState<boolean>(false);

  const onMouseEnter = useCallback(() => {
    setIsRowHovered(true);
  }, []);
  const onMouseLeave = useCallback(() => {
    setIsRowHovered(false);
  }, []);

  useEffect(() => {
    node.addEventListener('mouseEnter', onMouseEnter);
    node.addEventListener('mouseLeave', onMouseLeave);
    return () => {
      node.removeEventListener('mouseEnter', onMouseEnter);
      node.removeEventListener('mouseLeave', onMouseLeave);
    };
  }, [node, onMouseEnter, onMouseLeave]);

  const entityPrimaryFieldValue = useMemo(() => {
    if (Array.isArray(value)) {
      if (value.length === 1) {
        return value[0];
      }
      return undefined;
    }

    return value;
  }, [value]);

  if (!entityDefinition) {
    return null;
  }

  if (
    entityDetails &&
    entityDetails.selectedEntity &&
    entityDetails.selectedEntity.type.id === entityDefinition.entity.id
  ) {
    return null;
  }

  if (!isRowHovered || value === undefined) {
    return null;
  }

  if (!entityDefinition.entity.isEnabled) {
    return null;
  }

  if (!entityPrimaryFieldValue) {
    return null;
  }

  return (
    <div style={{ marginLeft: 8 }}>
      <EntityButtons.Link
        entity={entityDefinition.entity}
        entityPrimaryFieldValue={entityPrimaryFieldValue}
        app={entityDefinition.app}
      />
    </div>
  );
};

export default EntityLink;
